import { forwardRef, Type } from '@angular/core';

import { WithDisabled, WithDisabledToken } from './with-disabled.component';

/**
 * Creates provider that registers the component as component that can be disabled.
 *
 * @param type type of the component
 * @return provider for the given type
 * */
export function disabledProviderFactory<T extends WithDisabled>(type: Type<T>) {
  return {
    provide: WithDisabledToken,
    useExisting: forwardRef(() => type)
  };
}
